<template>
    <v-toolbar app dark class="black header">

        <v-toolbar-items>
            <div class="header">
                <router-link to="/home"><img class="logo" src="../assets/logoTest.png"/></router-link>
            </div>
    </v-toolbar-items>

        <v-divider></v-divider>

        <v-toolbar-items class="hidden-xs-only btn">
            <v-menu offset-y dark>
                <v-btn
                        flat
                        target="_blank"
                        slot="activator">
                    <span class="mr-2">Nos services</span>
                </v-btn>
                <v-list>
                    <v-list-tile class="text-uppercase">
                        <v-btn
                                flat
                                to="/particulier">Particulier</v-btn>
                    </v-list-tile>
                    <v-list-tile class="text-uppercase">
                        <v-btn
                                flat
                                to="/corporatif">Corporatif</v-btn>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar-items>

        <v-toolbar-items class="hidden-xs-only btn">
            <v-menu offset-y dark>
                <v-btn
                        flat
                        target="_blank"
                        slot="activator">
                    <span class="mr-2">À propos</span>
                </v-btn>
                <v-list>
                  <!--  <v-list-tile class="text-uppercase">
                        <v-btn
                                flat
                                to="/">Qui sommes-nous?</v-btn>
                    </v-list-tile>
                    <v-list-tile class="text-uppercase">
                        <v-btn
                                flat
                                to="/">Notre mission</v-btn>
                    </v-list-tile>-->
                    <v-list-tile class="text-uppercase">
                        <v-btn
                                flat
                                to="/medias">Médias</v-btn>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar-items>

        <v-toolbar-items class="hidden-xs-only btn">
        <v-btn flat to="/contact">
            <span class="mr-2">Nous contacter</span>
        </v-btn>
        </v-toolbar-items>

        <v-spacer></v-spacer>

       <!-- <v-toolbar-items class="hidden-xs-only">
        <span class="mr-2">
            <v-avatar :tile="tile"
                      :size="avatarSize"
                      color="blue">
                <v-icon>account_circle</v-icon>
            </v-avatar>
          </span>
        </v-toolbar-items>-->

        <v-menu right transition="scale-transition" class="hidden-sm-and-up">
            <v-toolbar-side-icon class="hidden-md-and-up" slot="activator"></v-toolbar-side-icon>
            <v-list>
                <v-list-tile>
                    <v-btn flat active-class to="/Home">Accueil</v-btn>
                </v-list-tile>
                <v-list-tile>
                    <v-btn flat active-class to="/particulier">Nos services</v-btn>
                </v-list-tile>
                <v-list-tile>
                    <v-btn flat active-class to="/medias">Médias</v-btn>
                </v-list-tile>
                <v-list-tile>
                    <v-btn flat active-class to="/contact">Nous contacter</v-btn>
                </v-list-tile>
            </v-list>
        </v-menu>

        <v-btn
                absolute
                large
                dark
                x-large
                color="#009688"
                bottom
                round
                to="/contact"
                id="reserver">
            Réservez
        </v-btn>

    </v-toolbar>
</template>

<script>
    export default {
        name: "Navigaton",
        data: ()=> ({

        })
    }
</script>

<style scoped>
    #reserver {
        left: 75%;
        font-size: 2vw;
        font-family: Arial;
    }

    .header {
        height: 80px;
        padding-top: 5px;
    }


    .logo{
        width:100%;
    }


    @media only screen and (max-width: 600px) {
        .header {
            height: 70px;
        }

        #reserver {
            font-size: 4vw;
            left: 60%;
        }
    }

    .decoration {
        text-decoration: none;
        color: white;
    }

</style>
